var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"back-btn",on:{"click":_vm.goBack}},[_vm._v(" "+_vm._s(_vm.$t('buttons.back'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }